export const ORG_URL = 'https://github.com/dopejs';
export const SITE_REPO_URL = 'https://github.com/dopejs/homepage';
